import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row border-bottom pb-2" };
const _hoisted_2 = { class: "col-1 d-flex align-items-center justify-content-center" };
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center bg-light border w-100 h-100" };
const _hoisted_4 = { class: "col-4 d-flex align-items-center" };
const _hoisted_5 = { class: "col-1 d-flex align-items-center justify-content-center" };
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center bg-light border w-100 h-100" };
const _hoisted_7 = { class: "col-4 d-flex align-items-center justify-content-center" };
const _hoisted_8 = { class: "d-flex align-items-center justify-content-center w-100 h-100" };
const _hoisted_9 = { class: "row border-bottom pb-2" };
const _hoisted_10 = { class: "col-4 d-flex align-items-center justify-content-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.record.number), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_g_text_field, {
                    placeholder: "Text auf Schild",
                    "data-member": "text",
                    "data-object": _ctx._row,
                    "data-mode": "model",
                    site: "small",
                    "field-class": "m-0"
                }, null, 8, ["data-object"])
            ]),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx._row.text_length), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_g_button, {
                        text: "Löschen",
                        onClick: _ctx.OnDelete,
                        "button-style": "btn-outline-danger"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_g_button, {
                        text: "Legendschild",
                        onClick: _ctx.OnAddRow
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_g_button, {
                        text: "Erläuterungsschild",
                        onClick: _ctx.OnAddRow
                    }, null, 8, ["onClick"])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_g_button, {
                    text: "Weitere Schild",
                    onClick: _ctx.OnAddRow
                }, null, 8, ["onClick"])
            ])
        ])
    ], 64));
}
